// extracted by mini-css-extract-plugin
export default {"timeInfo":"DetailsModal_timeInfo__TfY4y","createTimeInfo":"DetailsModal_createTimeInfo__Rpgmm","updateTimeInfo":"DetailsModal_updateTimeInfo__D0be8"};